// AUTO-GENERATED before every build/serve by scripts/generate-version.js — do not edit by hand.
export const BUILD_INFO = {
  version: '20261030.151759',
  buildTime: '2026-10-30T10:17:59.137Z',
  commit: '1511149',
};
